import { combineReducers } from "redux";

function ProvisionReducer() {
  const provisionWristbandInitialState = {
    error: null,
    loading: false,
  };

  const provisionSensorInitialState = {
    error: null,
    loading: false,
  };

  const provisionCodeInitialState = {
    previousProvisionCodes: null,
    code: null,
    error: null,
    loading: false,
    activatePreviousProvisionCodeLoading: false,
    activatePreviousProvisionCodeError: false,
  };

  const wristband = (state = provisionWristbandInitialState, action) => {
    const { type } = action;

    switch (type) {
      case "TOGGLE_PROVISION_SUCCESS":
        return {
          ...state,
          error: null,
        };
      case "PROVISION_WRISTBAND_INIT":
        return {
          ...state,
          loading: true,
          error: null,
        };
      case "PROVISION_WRISTBAND_SUCCESS":
        return {
          ...state,
          loading: false,
          error: false,
        };
      case "PROVISION_WRISTBAND_ERROR":
        return {
          ...state,
          loading: false,
          error: action.payload || "Provisioning failed",
        };
      default:
        return state;
    }
  };

  const sensorProvision = (state = provisionSensorInitialState, action) => {
    const { type } = action;

    switch (type) {
      case "TOGGLE_PROVISION_SUCCESS":
        return {
          ...state,
          error: null,
        };
      case "PROVISION_SENSOR_INIT":
        return {
          ...state,
          loading: true,
          error: null,
        };
      case "PROVISION_SENSOR_SUCCESS":
        return {
          ...state,
          loading: false,
          error: false,
        };
      case "PROVISION_SENSOR_ERROR":
        return {
          ...state,
          loading: false,
          error: action.payload || "Provisioning failed",
        };
      default:
        return state;
    }
  };

  const provisionCode = (state = provisionCodeInitialState, action) => {
    const { type, payload } = action;

    switch (type) {
      case "REQUEST_PROVISION_CODE_INIT":
        return {
          ...state,
          code: null,
          loading: true,
          error: null,
        };
      case "REQUEST_PROVISION_CODE_SUCCESS":
        return {
          ...state,
          code: payload,
          loading: false,
          error: false,
        };
      case "REQUEST_PROVISION_CODE_ERROR":
        return {
          ...state,
          loading: false,
          code: null,
          error: action.payload || "Provisioning failed",
        };
      case "GET_PROVISION_CODES_INIT":
        return {
          ...state,
          previousProvisionCodes: null,
          previousProvisionCodesLoading: true,
          previousProvisionCodesError: false,
        };
      case "GET_PROVISION_CODES_SUCCESS":
        return {
          ...state,
          previousProvisionCodes: payload,
          previousProvisionCodesLoading: false,
          previousProvisionCodesError: false,
        };
      case "GET_PROVISION_CODES_ERROR":
        return {
          ...state,
          previousProvisionCodes: [],
          previousProvisionCodesLoading: false,
          previousProvisionCodesError: true,
        };
      case "ACTIVATE_PROVISION_CODE_INIT":
        return {
          ...state,
          activatePreviousProvisionCodeLoading: true,
          activatePreviousProvisionCodeError: false,
        };
      case "ACTIVATE_PROVISION_CODE_SUCCESS":
        return {
          ...state,
          previousProvisionCodes: state.previousProvisionCodes.map((c) => {
            if (
              c.systemProvisionRequestId == payload.systemProvisionRequestId
            ) {
              c = payload;
            }

            return c;
          }),
          activatePreviousProvisionCodeLoading: false,
          activatePreviousProvisionCodeError: false,
        };
      case "ACTIVATE_PROVISION_CODE_ERROR":
        return {
          ...state,
          activatePreviousProvisionCodeLoading: false,
          activatePreviousProvisionCodeError: true,
        };
      default:
        return state;
    }
  };

  return combineReducers({
    wristband,
    sensorProvision,
    provisionCode,
  });
}

export default ProvisionReducer();
